import { LitElement, html, css } from '@hh/global.js'

class HHAccordion extends LitElement {
  static properties = {
    open: {
      type: Boolean,
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  toggle() {
    this.open = !this.open
  }

  render() {
    return html`
      <div class="accordion" aria-expanded="${this.open}">
        <button type="button" class="head" @click=${this.toggle}>
          <span class="title">
            <slot name="title"></slot>
          </span>
        </button>

        <div class="content">
          <slot name="content"></slot>
        </div>
      </div>
    `
  }

  static styles = css`
    .accordion {
      display: flex;
      flex-direction: column;
      border-top: var(--hh-accordion-border-top, none);
      border-bottom: 0.1rem solid var(--hh-color-brand-secondary);
    }

    :host([open]) .accordion {
      border-bottom: var(--hh-accordion-open-border-bottom, 0.1rem solid var(--hh-color-brand-secondary) );
    }

    .head {
      color: currentColor;
      background: none;
      font: inherit;
      text-align: left;
      padding: 0;
      border: none;
      margin: 0;
      cursor: pointer;
      position: relative;
    }

    .head::before,
    .head::after {
      content: '';
      background-color: currentColor;
      width: 1rem;
      height: 0.1rem;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate3d(0, -50%, 0);
    }

    .head:after {
      transform: translate3d(0, -50%, 0) rotate(90deg);
      transition: transform 0.3s ease-in-out;
    }

    :host([open]) .head:after {
      transform: translate3d(0, -50%, 0) rotate(360deg);
    }

    .content > :first-child {
      margin-bottom: 20px;
    }

    .content {
      overflow: hidden;
      max-height: 0px;
      transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
    }

    :host([open]) .content {
      max-height: 1000px;
      transition: max-height 3s ease-in-out;
      margin-top: -10px;
      margin-bottom: var(--hh-accordion-open-margin-bottom,2rem);
    }
  `
}

customElements.define('hh-accordion', HHAccordion)
